import React, { ReactElement } from 'react';
import AccidentCard from '../AccidentCard/AccidentCard';
import AutoTreatmentDetailCard from '../AutoTreatmentDetailCard/AutoTreatmentDetailCard';
import CovidCaseCard from '../CovidCaseCard/CovidCaseCard';
import PastHistoryCard from '../PastHistoryCard/PastHistoryCard';

const AutomatedTreatmentDetail = ({ isLoading, form }: any): ReactElement => {
  return (
    <React.Fragment>
      <AutoTreatmentDetailCard isLoading={isLoading} form={form} />
      <CovidCaseCard isLoading={isLoading} form={form} />
      <PastHistoryCard isLoading={isLoading} form={form} />
      <AccidentCard isLoading={isLoading} form={form} />
    </React.Fragment>
  );
};
export default AutomatedTreatmentDetail;
